import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import Title from "../../../learning/presentational/header/Title";
import ClosePopup from "../popup/ClosePopup";
import AnsweringInfo from "./answeringInfo/AnsweringInfo";

const Header = ( props ) => {

  const { t } = useTranslation();

  const {
    Closer,
    AccuracyLabelChanger,
    children,
    ...PROPS
  } = props;

  return (
    <div className="header test_gm">
      <div className="inner">
        <div className="headerBox">
          <div className="headerBox_head">
            <Title>{ t( 'LC_02_06.msg001' ) }</Title>
            <Closer><ClosePopup><button className="btn-close-wrap">닫기</button></ClosePopup></Closer>
          </div>
          <div className="headerBox_body">
            <AccuracyLabelChanger><AnsweringInfo { ...PROPS } /></AccuracyLabelChanger>
          </div>
        </div>
      </div>
    </div>
  );

};

Header.defaultProps = {
  Closer : Fragment,
  AccuracyLabelChanger : Fragment
};

export default Header;
